/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'

import { watchCookiebotConsent } from '@mos/client/shared/consent/cookiebot-consent'
import * as Sentry from '@sentry/angular'
import { build_version } from './environments/version'

if (environment.production) {
	enableProdMode()

	// staging/preprod/prod share this same build - SERVER_ENVIRONMENT is only known at
	// runtime via nginx-templated env.json, so it can't be baked in at build time here.
	fetch('/env.json')
		.then((res) => res.json())
		.catch(() => ({}) as { environment?: string })
		.then(({ environment: serverEnvironment }: { environment?: string }) => {
			Sentry.init({
				dsn: 'https://480646107bb260218255026a7e3251ba@o4508596186513408.ingest.de.sentry.io/4508609004896336',
				environment: serverEnvironment ?? 'prod',
				release: build_version,
				integrations: [
					// Registers and configures the Tracing integration,
					// which automatically instruments your application to monitor its
					// performance, including custom Angular routing instrumentation
					Sentry.browserTracingIntegration(),
					// Session Replay is only added once statistics cookies are accepted - see below
				],

				tracesSampleRate: 1.0,

				// Scoped to the API only (not a bare 'memoryofsouls.fr' substring match) - that string also
				// matched the assets.*.memoryofsouls.fr R2 domain, so Sentry was injecting sentry-trace/baggage
				// headers into the scene player/journal's asset fetch() calls, tripping their CORS preflight
				// (the R2 bucket's CORS policy declares no allowed request headers).
				tracePropagationTargets: ['localhost', /^https:\/\/api(\.(staging|preprod))?\.memoryofsouls\.(fr|com)/],
				replaysSessionSampleRate: 0.1,
				replaysOnErrorSampleRate: 1.0,
			})

			// Session Replay stores a session id (sentryReplaySession) and records the screen, so it needs
			// the visitor's statistics consent: it starts once Cookiebot reports it, and stops if it's withdrawn.
			let replayAdded = false
			watchCookiebotConsent('statistics', (granted) => {
				if (granted && !replayAdded) {
					replayAdded = true
					Sentry.addIntegration(Sentry.replayIntegration({ maskAllText: true }))
					Sentry.addIntegration(Sentry.replayCanvasIntegration())
				} else if (!granted) {
					void Sentry.getReplay()?.stop()
				}
			})
		})
}

bootstrapApplication(AppComponent, appConfig).catch((error) => console.error('Application error', error))
